<template>
  <div>
    <el-row :gutter="40" class="topInfo">
      <el-col :xs="12" :sm="12" :lg="6">
        <div class="infoBox" style="background-color: #00b5f9">
          <div>
            <div style="text-align: center;margin-bottom: 10px;font-size:22px">加入云蓝科技</div>
            <div class="f22 flex justify-around align-center">
              <div style="font-size:26px;font-weight:700">100</div>
              <div>天</div>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :xs="12" :sm="12" :lg="6">
        <div class="infoBox" style="background-color: #f8ba74">
          <div>
            <div class="f26" style="text-align: center;margin-bottom: 10px;font-size:22px">工作日志</div>
            <div class="f22 flex justify-around align-center">
              <div style="font-size:26px;font-weight:700">100</div>
              <div>条</div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="40" class="panel-group">
      <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
        <div class="card-panel" @click="goWork">
          <div class="card-panel-icon-wrapper icon-people">
            <i class="el-icon-s-custom f50" />
          </div>
          <div class="card-panel-description">
            <!-- <div class="card-panel-text">工作台</div> -->
            <div class="f22" style="margin-top:10px">工作台</div>
          </div>
        </div>
      </el-col>
      <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
        <div class="card-panel" @click="goProjectManage">
          <div class="card-panel-icon-wrapper icon-message">
            <i class="el-icon-s-comment f50" />
          </div>
          <div class="card-panel-description">
            <!-- <div class="card-panel-text">Messages</div> -->
            <div class="f22" style="margin-top:10px">项目管理</div>
          </div>
        </div>
      </el-col>
      <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
        <div class="card-panel" @click="goDailyRecoeds">
          <div class="card-panel-icon-wrapper icon-money">
            <i class="el-icon-s-promotion f50" />
          </div>
          <div class="card-panel-description">
            <!-- <div class="card-panel-text">Purchases</div> -->
            <div class="f22" style="margin-top:10px">工作日志</div>
          </div>
        </div>
      </el-col>
      <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
        <div class="card-panel" @click="goCustom">
          <div class="card-panel-icon-wrapper icon-shopping">
            <i class="el-icon-s-order f50" />
          </div>
          <div class="card-panel-description">
            <!-- <div class="card-panel-text">Shoppings</div> -->
            <div class="f22" style="margin-top:10px">客户管理</div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      
    }
  },
  methods:{
    goWork(){
      // this.$router.push({
      //   path: "/workbench"
      // });
    },
    goProjectManage(){
      // this.$router.push({
      //   path: "/projectManage"
      // });
    },
    goDailyRecoeds(){
      // this.$router.push({
      //   path: "/workDiary"
      // });
    },
    goCustom(){
      // this.$router.push({
      //   path: "/customer"
      // });
    }
  }
};
</script>

<style lang="less" scoped>
.topInfo {
  padding: 0 30px;
  box-sizing: border-box;
  color: #fff;
  .infoBox {
    height: 108px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.panel-group {
  margin-top: 18px;
  padding: 0 30px;
  box-sizing: border-box;

  .card-panel-col {
    margin-bottom: 32px;
  }

  .card-panel {
    height: 108px;
    cursor: pointer;
    font-size: 12px;
    position: relative;
    overflow: hidden;
    color: #666;
    background: #fff;
    box-shadow: 4px 4px 40px rgba(0, 0, 0, 0.05);
    border-color: rgba(0, 0, 0, 0.05);

    &:hover {
      .card-panel-icon-wrapper {
        color: #fff;
      }

      .icon-people {
        background: #40c9c6;
      }

      .icon-message {
        background: #36a3f7;
      }

      .icon-money {
        background: #f4516c;
      }

      .icon-shopping {
        background: #34bfa3;
      }
    }

    .icon-people {
      color: #40c9c6;
    }

    .icon-message {
      color: #36a3f7;
    }

    .icon-money {
      color: #f4516c;
    }

    .icon-shopping {
      color: #34bfa3;
    }

    .card-panel-icon-wrapper {
      float: left;
      margin: 14px 0 0 14px;
      padding: 16px;
      transition: all 0.38s ease-out;
      border-radius: 6px;
    }

    .card-panel-icon {
      float: left;
      font-size: 48px;
    }

    .card-panel-description {
      float: right;
      font-weight: bold;
      margin: 26px;
      margin-left: 0px;

      .card-panel-text {
        line-height: 18px;
        color: rgba(0, 0, 0, 0.45);
        font-size: 16px;
        margin-bottom: 20px;
      }

      .card-panel-num {
        font-size: 20px;
      }
    }
  }
}

@media (max-width: 550px) {
  .card-panel-description {
    display: none;
  }

  .card-panel-icon-wrapper {
    float: none !important;
    width: 100%;
    height: 100%;
    margin: 0 !important;
  }
}
</style>
